import { bindActionCreators } from "@reduxjs/toolkit"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { IfFundTerms, IfInvestmentLimits, IfIrr, IfOther, IfOverview, IfPrivateDebtCharacteristics, IfPrivateDebtExtraInfo, defaultIfPrivateDebtExtraInfo, FileSrc } from "../../AssetContext"
import { actionCreators } from "../../state"
import { TitleColor1 } from "../typography/Typogtaphy"
import UploadFilesForm, { UploadTokenFilesForm } from "../UploadFilesForm"
import LabelAndInput from "./../LabelAndInput"
import { OptimizedImage, SortedImages, sortImages } from "../../functions/images"
import { sanitizeInputField } from "../../utils"
import UploadCardImage from "../UploadCardImage"
import ExtraInfoFormContainer from "./utils/ExtraInfoFormContainer"
import ExtraInfoFileUpload, { UploadUtils } from "./utils/ExtraInfoFileUpload"

export default function ExtraInfoPrivateDebtForm(props: {
    assetInfo: any, setUpdateFun: any, media: any,
    uploadUtils: UploadUtils
}): JSX.Element {

    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    // Asset ExtraInfo fields
    const [assetName, setAssetName] = useState<string>("")
    //irr
    const [targetGrossIrr, setTargetGrossIrr] = useState<string>("")
    const [targetCashYield, setTargetCashYield] = useState<string>("")
    const [distributionPolicy, setDistributionPolicy] = useState<string>("")
    //other
    const [ifm, setIfm] = useState<string>("")
    const [auditor, setAuditor] = useState<string>("")
    const [custodian, setCustodian] = useState<string>("")
    const [reporting, setReporting] = useState<string>("")
    const [distributor, setDistributor] = useState<string>("")
    const [administrator, setAdministrator] = useState<string>("")
    const [navFrequency, setNavFrequency] = useState<string>("")
    const [shareClasses, setShareClasses] = useState<string>("")
    const [incentiveFees, setIncentiveFees] = useState<string>("")
    const [generalPartner, setGeneralPartner] = useState<string>("")
    const [legalStructure, setLegalStructure] = useState<string>("")
    const [managementFees, setManagementFees] = useState<string>("")
    const [subDistributor, setSubDistributor] = useState<string>("")
    const [portfolioManager, setPortfolioManager] = useState<string>("")
    //overview
    const [dealType, setDealType] = useState<string>("")
    const [fundName, setFundName] = useState<string>("")
    const [targetFundSize, setTargetFundSize] = useState<string>("")
    const [overviewInvestmentPeriod, setOverviewInvestmentPeriod] = useState<string>("")
    const [riskReturnCharacteristics, setRiskReturnCharacteristics] = useState<string>("")
    const [targetAllocation, setTargetAllocation] = useState<string>("")
    //fund terms
    const [rampUp, setRampUp] = useState<string>("")
    const [fundTerm, setFundTerm] = useState<string>("")
    const [finalClose, setFinalClose] = useState<string>("")
    const [firstClose, setFirstClose] = useState<string>("")
    const [fundTermsInvestmentPeriod, setFundTermsInvestmentPeriod] = useState<string>("")
    const [capitalRestitutions, setCapitalRestitutions] = useState<string>("")
    //characteristics
    const [covenant, setCovenant] = useState<string>("")
    const [dealCurrency, setDealCurrency] = useState<string>("")
    const [fundCurrency, setFundCurrency] = useState<string>("")
    const [averageRating, setAverageRating] = useState<string>("")
    const [loansOrBonds, setLoansOrBonds] = useState<string>("")
    const [minimumRating, setMinimumRating] = useState<string>("")
    const [numberOfDeals, setNumberOfDeals] = useState<string>("")
    const [borrowerProfile, setBorrowerProfile] = useState<string>("")
    const [targetDealSize, setTargetDealSize] = useState<string>("")
    const [floatingOrFixed, setFloatingOrFixed] = useState<string>("")
    const [typeOfCollateral, setTypeOfCollateral] = useState<string>("")
    const [speedOfDeployment, setSpeedOfDeployment] = useState<string>("")
    const [targetCompanySize, setTargetCompanySize] = useState<string>("")
    const [bulletOrAmortizing, setBulletOrAmortizing] = useState<string>("")
    const [primarySecondary, setPrimarySecondary] = useState<string>("")
    const [sponsorOrCorporate, setSponsorOrCorporate] = useState<string>("")
    const [typicalLoanToValue, setTypicalLoanToValue] = useState<string>("")
    const [expectedTermPerDeal, setExpectedTermPerDeal] = useState<string>("")
    const [maxAverageNetLeverage, setMaxAverageNetLeverage] = useState<string>("")
    const [maxTypicalTermPerDeal, setMaxTypicalTermPerDeal] = useState<string>("")
    //Investment restrictions
    const [leverage, setLeverage] = useState<string>("")
    const [derivatives, setDerivatives] = useState<string>("")
    const [geographicArea, setGeographicArea] = useState<string>("")
    const [maxIssuerLimit, setMaxIssuerLimit] = useState<string>("")
    const [maxSectorLimit, setMaxSectorLimit] = useState<string>("")
    const [esgConsiderations, setEsgConsiderations] = useState<string>("")
    const [excludedProfiles, setExcludedProfiles] = useState<string>("")
    const [maxCountryLimit, setMaxCountryLimit] = useState<string>("")
    const [interestCoverageRatio, setInterestCoverageRatio] = useState<string>("")

    const [images2, setImages2] = useState<FileSrc[]>([])
    const [documents, setDocuments] = useState<FileSrc[]>([])
    const [coownership, setCoownership] = useState<FileSrc[]>([])
    const [prospectus, setProspectus] = useState<FileSrc[]>([])

    const [isApprovedAndTokenized, setIsApprovedAndTokenized] = useState<boolean>(false)
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false)

    var newIrrInfo: IfIrr = {
        //target_moic : targetMoic,
        target_gross_irr: sanitizeInputField(targetGrossIrr),
        target_cash_yield: sanitizeInputField(targetCashYield),
        distribution_policy: sanitizeInputField(distributionPolicy)
    }

    var newOtherInfo: IfOther = {
        IFM: sanitizeInputField(ifm),
        auditor: sanitizeInputField(auditor),
        custodian: sanitizeInputField(custodian),
        reporting: (reporting),
        distributor: sanitizeInputField(distributor),
        administrator: sanitizeInputField(administrator),
        nav_frequency: sanitizeInputField(navFrequency),
        share_classes: sanitizeInputField(shareClasses),
        incentive_fees: (incentiveFees),
        general_partner: sanitizeInputField(generalPartner),
        legal_structure: (legalStructure),
        management_fees: (managementFees),
        sub_distributor: sanitizeInputField(subDistributor),
        portfolio_manager: sanitizeInputField(portfolioManager),
        subsequent_subscriptions: ""//(subsequentSubscriptions)
    }

    var newOverviewInfo: IfOverview = {
        deal_type: sanitizeInputField(dealType),
        fund_name: sanitizeInputField(fundName),
        target_fund_size: sanitizeInputField(targetFundSize),
        investment_period: sanitizeInputField(overviewInvestmentPeriod),
        risk_return_characteristics: (riskReturnCharacteristics),
        target_allocation: (targetAllocation),
    }

    var newfund_termsrmsInfo: IfFundTerms = {
        ramp_up: sanitizeInputField(rampUp),
        fund_term: sanitizeInputField(fundTerm),
        final_close: sanitizeInputField(finalClose),
        first_close: sanitizeInputField(firstClose),
        capital_calls: "",//capitalCalls,
        investment_period: sanitizeInputField(fundTermsInvestmentPeriod),
        capital_restitutions: sanitizeInputField(capitalRestitutions)
    }

    var newCharacteristicsInfo: IfPrivateDebtCharacteristics = {
        covenant: sanitizeInputField(covenant),
        deal_currency: sanitizeInputField(dealCurrency),
        fund_currency: sanitizeInputField(fundCurrency),
        average_rating: sanitizeInputField(averageRating),
        loans_or_bonds: sanitizeInputField(loansOrBonds),
        minimum_rating: sanitizeInputField(minimumRating),
        number_of_deals: sanitizeInputField(numberOfDeals),
        borrower_profile: sanitizeInputField(borrowerProfile),
        target_deal_size: sanitizeInputField(targetDealSize),
        floating_or_fixed: sanitizeInputField(floatingOrFixed),
        type_of_collateral: (typeOfCollateral),
        speed_of_deployment: sanitizeInputField(speedOfDeployment),
        target_company_size: sanitizeInputField(targetCompanySize),
        bullet_or_amortizing: sanitizeInputField(bulletOrAmortizing),
        primary_or_secondary: sanitizeInputField(primarySecondary),
        sponsor_or_corporate: sanitizeInputField(sponsorOrCorporate),
        typical_loan_to_value: sanitizeInputField(typicalLoanToValue),
        expected_term_per_deal: sanitizeInputField(expectedTermPerDeal),
        max_average_net_leverage: sanitizeInputField(maxAverageNetLeverage),
        max_typical_term_per_deal: sanitizeInputField(maxTypicalTermPerDeal)
    }

    var newInvestmentLimitsInfo: IfInvestmentLimits = {
        leverage: sanitizeInputField(leverage),
        derivatives: sanitizeInputField(derivatives),
        geographic_area: sanitizeInputField(geographicArea),
        max_issuer_limit: sanitizeInputField(maxIssuerLimit),
        max_sector_limit: sanitizeInputField(maxSectorLimit),
        esg_considerations: (esgConsiderations),
        excluded_profiles: (excludedProfiles),
        max_country_limit: sanitizeInputField(maxCountryLimit),
        interest_coverage_ratio: sanitizeInputField(interestCoverageRatio)
    }

    var newPrivateDebtInfo: IfPrivateDebtExtraInfo = {
        irr: newIrrInfo,
        other: newOtherInfo,
        overview: newOverviewInfo,
        fund_terms: newfund_termsrmsInfo,
        characteristics: newCharacteristicsInfo,
        investment_limits: newInvestmentLimitsInfo
    }

    useEffect(() => {

        if (props.assetInfo.payload && props.assetInfo.payload.extra_info) {
            let ifPrivateDebt = defaultIfPrivateDebtExtraInfo
            if (props.assetInfo.payload.extra_info.private_debt) {
                ifPrivateDebt = props.assetInfo.payload.extra_info.private_debt.sub_assets ?
                    props.assetInfo.payload.extra_info.private_debt.sub_assets[0] :
                    defaultIfPrivateDebtExtraInfo
            }
            if (props.assetInfo.payload.asset_status_name !== "In Process" && props.assetInfo.payload.asset_status_name !== "Rejected")
                setIsApprovedAndTokenized(true)
            if (props.assetInfo.payload.asset_status_name === "Submitted")
                setIsSubmitted(true)

            setAssetName(props.assetInfo.payload.name)
            if (props) {

                setTargetGrossIrr(ifPrivateDebt.irr.target_gross_irr)
                setTargetCashYield(ifPrivateDebt.irr.target_cash_yield ? ifPrivateDebt.irr.target_cash_yield : "")
                setDistributionPolicy(ifPrivateDebt.irr.distribution_policy)

                setIfm(ifPrivateDebt.other.IFM)
                setAuditor(ifPrivateDebt.other.auditor)
                setCustodian(ifPrivateDebt.other.custodian)
                setReporting(ifPrivateDebt.other.reporting)
                setDistributor(ifPrivateDebt.other.distributor)
                setAdministrator(ifPrivateDebt.other.administrator)
                setNavFrequency(ifPrivateDebt.other.nav_frequency)
                setShareClasses(ifPrivateDebt.other.share_classes)
                setIncentiveFees(ifPrivateDebt.other.incentive_fees)
                setGeneralPartner(ifPrivateDebt.other.general_partner ? ifPrivateDebt.other.general_partner : "")
                setLegalStructure(ifPrivateDebt.other.legal_structure ? ifPrivateDebt.other.legal_structure : "")
                setManagementFees(ifPrivateDebt.other.management_fees)
                setSubDistributor(ifPrivateDebt.other.sub_distributor)
                setPortfolioManager(ifPrivateDebt.other.portfolio_manager)

                setDealType(ifPrivateDebt.overview.deal_type)
                setFundName(ifPrivateDebt.overview.fund_name)
                setTargetFundSize(ifPrivateDebt.overview.target_fund_size)
                setOverviewInvestmentPeriod(ifPrivateDebt.overview.investment_period ? ifPrivateDebt.overview.investment_period : "")
                setRiskReturnCharacteristics(ifPrivateDebt.overview.risk_return_characteristics)
                setTargetAllocation(ifPrivateDebt.overview.target_allocation)

                setRampUp(ifPrivateDebt.fund_terms.ramp_up)
                setFundTerm(ifPrivateDebt.fund_terms.fund_term)
                setFinalClose(ifPrivateDebt.fund_terms.final_close)
                setFirstClose(ifPrivateDebt.fund_terms.first_close)
                setFundTermsInvestmentPeriod(ifPrivateDebt.fund_terms.investment_period)
                setCapitalRestitutions(ifPrivateDebt.fund_terms.capital_restitutions)

                setCovenant(ifPrivateDebt.characteristics.covenant)
                setDealCurrency(ifPrivateDebt.characteristics.deal_currency)
                setFundCurrency(ifPrivateDebt.characteristics.fund_currency)
                setAverageRating(ifPrivateDebt.characteristics.average_rating)
                setLoansOrBonds(ifPrivateDebt.characteristics.loans_or_bonds)
                setMinimumRating(ifPrivateDebt.characteristics.minimum_rating)
                setNumberOfDeals(ifPrivateDebt.characteristics.number_of_deals)
                setBorrowerProfile(ifPrivateDebt.characteristics.borrower_profile)
                setTargetDealSize(ifPrivateDebt.characteristics.target_deal_size)
                setFloatingOrFixed(ifPrivateDebt.characteristics.floating_or_fixed)
                setTypeOfCollateral(ifPrivateDebt.characteristics.type_of_collateral)
                setSpeedOfDeployment(ifPrivateDebt.characteristics.speed_of_deployment)
                setTargetCompanySize(ifPrivateDebt.characteristics.target_company_size)
                setBulletOrAmortizing(ifPrivateDebt.characteristics.bullet_or_amortizing)
                setPrimarySecondary(ifPrivateDebt.characteristics.primary_or_secondary)
                setSponsorOrCorporate(ifPrivateDebt.characteristics.sponsor_or_corporate)
                setTypicalLoanToValue(ifPrivateDebt.characteristics.typical_loan_to_value)
                setExpectedTermPerDeal(ifPrivateDebt.characteristics.expected_term_per_deal)
                setMaxAverageNetLeverage(ifPrivateDebt.characteristics.max_average_net_leverage)
                setMaxTypicalTermPerDeal(ifPrivateDebt.characteristics.max_typical_term_per_deal)

                setLeverage(ifPrivateDebt.investment_limits.leverage)
                setDerivatives(ifPrivateDebt.investment_limits.derivatives)
                setGeographicArea(ifPrivateDebt.investment_limits.geographic_area)
                setMaxIssuerLimit(ifPrivateDebt.investment_limits.max_issuer_limit)
                setMaxSectorLimit(ifPrivateDebt.investment_limits.max_sector_limit)
                setEsgConsiderations(ifPrivateDebt.investment_limits.esg_considerations)
                setExcludedProfiles(ifPrivateDebt.investment_limits.excluded_profiles)
                setMaxCountryLimit(ifPrivateDebt.investment_limits.max_country_limit)
                setInterestCoverageRatio(ifPrivateDebt.investment_limits.interest_coverage_ratio)

            }
        }
    }, [props.assetInfo.payload])

    function updateEI() {
        var subAsset: any[] = []
        subAsset.push(newPrivateDebtInfo)
        const assetExtraInfo = {
            private_debt: {
                sub_assets: subAsset
            }
        }
        return assetExtraInfo
    }

    useEffect(() => {
        props.setUpdateFun(updateEI)
    }, [
        assetName, targetGrossIrr, targetCashYield, distributionPolicy, ifm, auditor, custodian, reporting, distributor, administrator,
        navFrequency, shareClasses, incentiveFees, generalPartner, legalStructure, managementFees, subDistributor, portfolioManager,
        dealType, fundName, targetFundSize, overviewInvestmentPeriod, riskReturnCharacteristics, targetAllocation,
        rampUp, fundTerm, finalClose, firstClose, fundTermsInvestmentPeriod, capitalRestitutions, covenant, dealCurrency,
        fundCurrency, averageRating, loansOrBonds, minimumRating, numberOfDeals, borrowerProfile, targetDealSize, floatingOrFixed,
        typeOfCollateral, speedOfDeployment, targetCompanySize, bulletOrAmortizing, primarySecondary, sponsorOrCorporate,
        typicalLoanToValue, expectedTermPerDeal, maxAverageNetLeverage, maxTypicalTermPerDeal, leverage, derivatives, geographicArea,
        maxIssuerLimit, maxSectorLimit, esgConsiderations, excludedProfiles, maxCountryLimit, interestCoverageRatio])

    return <>
        <ExtraInfoFormContainer>
            <LabelAndInput id={"assetName"} label={"Asset Name"} value={assetName} fun={setAssetName} type={"disabled"} className={"col-span-12"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Overview</TitleColor1>

            <LabelAndInput id={"fundName"} label={"Fund Name *"} value={fundName} fun={setFundName} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"overviewInvestmentPeriod"} label={"Investment Period *"} value={overviewInvestmentPeriod} fun={setOverviewInvestmentPeriod} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"dealType"} label={"Deal Type *"} value={dealType} fun={setDealType} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"targetAllocation"} label={"Target Allocation / Seniority *"} value={targetAllocation} fun={setTargetAllocation} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"riskReturnCharacteristics"} label={"Risk & Return Characteristics *"} value={riskReturnCharacteristics} fun={setRiskReturnCharacteristics} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"targetFundSize"} label={"Target Fund Size *"} value={targetFundSize} fun={setTargetFundSize} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Characteristics</TitleColor1>

            <LabelAndInput id={"borrowerProfile"} label={"Borrower Profile *"} value={borrowerProfile} fun={setBorrowerProfile} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"loansOrBonds"} label={"Loans Or Bonds *"} value={loansOrBonds} fun={setLoansOrBonds} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"bulletOrAmortizing"} label={"Bullet Or Amortizing *"} value={bulletOrAmortizing} fun={setBulletOrAmortizing} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"floatingOrFixed"} label={"Floating Or Fixed *"} value={floatingOrFixed} fun={setFloatingOrFixed} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"primaryOrSecondary"} label={"Primary Or Secondary *"} value={primarySecondary} fun={setPrimarySecondary} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"sponsorOrCorporate"} label={"Sponsor Or Corporate *"} value={sponsorOrCorporate} fun={setSponsorOrCorporate} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"covenant"} label={"Covenant *"} value={covenant} fun={setCovenant} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"targetCompanySize"} label={"Target Company Size *"} value={targetCompanySize} fun={setTargetCompanySize} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"averageRating"} label={"Average Rating *"} value={averageRating} fun={setAverageRating} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"minimumRating"} label={"Minimum Rating *"} value={minimumRating} fun={setMinimumRating} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"typicalLoanToValue"} label={"Typical Loan To Value *"} value={typicalLoanToValue} fun={setTypicalLoanToValue} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"typeOfCollateral"} label={"Type Of Collateral *"} value={typeOfCollateral} fun={setTypeOfCollateral} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"maxAverageNetLeverage"} label={"Max / Average Net Leverage *"} value={maxAverageNetLeverage} fun={setMaxAverageNetLeverage} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"dealCurrency"} label={"Deal Currency *"} value={dealCurrency} fun={setDealCurrency} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"fundCurrency"} label={"Fund Currency *"} value={fundCurrency} fun={setFundCurrency} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"maxTypicalTermPerDeal"} label={"Max / Typical Term Per Deal *"} value={maxTypicalTermPerDeal} fun={setMaxTypicalTermPerDeal} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"expectedTermPerDeal"} label={"Expected Term Per Deal *"} value={expectedTermPerDeal} fun={setExpectedTermPerDeal} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"targetDealSize"} label={"Target Deal Size *"} value={targetDealSize} fun={setTargetDealSize} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"numberOfDeals"} label={"Number Of Deals *"} value={numberOfDeals} fun={setNumberOfDeals} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"speedOfDeployment"} label={"Speed Of Deployment *"} value={speedOfDeployment} fun={setSpeedOfDeployment} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Investment Restrictions</TitleColor1>

            <LabelAndInput id={"geographicArea"} label={"Geographic Area *"} value={geographicArea} fun={setGeographicArea} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"maxCountryLimit"} label={"Max Country Limit *"} value={maxCountryLimit} fun={setMaxCountryLimit} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"maxSectorLimit"} label={"Max Sector Limit *"} value={maxSectorLimit} fun={setMaxSectorLimit} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"maxIssuerLimit"} label={"Max Issuer Limit *"} value={maxIssuerLimit} fun={setMaxIssuerLimit} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"excludedProfiles"} label={"Excluded Profiles *"} value={excludedProfiles} fun={setExcludedProfiles} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"interestCoverageRatio"} label={"Interest Coverage Ratio *"} value={interestCoverageRatio} fun={setInterestCoverageRatio} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-12"} required />
            <LabelAndInput id={"esgConsiderations"} label={"ESG Consideration *"} value={esgConsiderations} fun={setEsgConsiderations} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"leverage"} label={"Leverage *"} value={leverage} fun={setLeverage} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"derivatives"} label={"Derivatives *"} value={derivatives} fun={setDerivatives} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ IRR</TitleColor1>

            <LabelAndInput id={"targetGrossIrr"} label={"Target Gross IRR *"} value={targetGrossIrr} fun={setTargetGrossIrr} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-4"} required />
            <LabelAndInput id={"targetCashYield"} label={"Target Chash Yield *"} value={targetCashYield} fun={setTargetCashYield} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-4"} required />
            <LabelAndInput id={"distributionPolicy"} label={"Distribution Policy *"} value={distributionPolicy} fun={setDistributionPolicy} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-4"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Fund Terms</TitleColor1>

            <LabelAndInput id={"firstClose"} label={"First Close *"} value={firstClose} fun={setFirstClose} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"finalClose"} label={"Final Close *"} value={finalClose} fun={setFinalClose} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"fundTerm"} label={"Fund Term *"} value={fundTerm} fun={setFundTerm} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"rampUp"} label={"Ramp Up *"} value={rampUp} fun={setRampUp} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"fundTermsInvestmentPeriod"} label={"Investment Period *"} value={fundTermsInvestmentPeriod} fun={setFundTermsInvestmentPeriod} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"capitalRestitutions"} label={"Capital Restitutions *"} value={capitalRestitutions} fun={setCapitalRestitutions} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />

            <TitleColor1 className="text-lg mt-5 col-span-12">/ Others</TitleColor1>

            <LabelAndInput id={"legalStructure"} label={"Legal Structure *"} value={legalStructure} fun={setLegalStructure} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"custodian"} label={"Custodian *"} value={custodian} fun={setCustodian} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"administrator"} label={"Administrator *"} value={administrator} fun={setAdministrator} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"auditor"} label={"Auditor *"} value={auditor} fun={setAuditor} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"generalPartner"} label={"General Partner *"} value={generalPartner} fun={setGeneralPartner} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"IFM"} label={"IFM *"} value={ifm} fun={setIfm} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"portfolioManager"} label={"Portfolio Manager *"} value={portfolioManager} fun={setPortfolioManager} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"managementFees"} label={"Management Fees *"} value={managementFees} fun={setManagementFees} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"incentiveFees"} label={"Incentive Fees *"} value={incentiveFees} fun={setIncentiveFees} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />
            <LabelAndInput id={"distributor"} label={"Distributor *"} value={distributor} fun={setDistributor} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"subDistributor"} label={"Sub Distributor *"} value={subDistributor} fun={setSubDistributor} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"shareClasses"} label={"Share Classes *"} value={shareClasses} fun={setShareClasses} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"navFrequency"} label={"Nav Frequency *"} value={navFrequency} fun={setNavFrequency} type={isApprovedAndTokenized ? "disabled" : "text"} className={"col-span-6"} required />
            <LabelAndInput id={"reporting"} label={"Reporting *"} value={reporting} fun={setReporting} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className={"col-span-12"} required />

            <ExtraInfoFileUpload assetName={props.assetInfo} isSubmitted={isSubmitted}
                coownership={coownership} setCoownership={setCoownership}
                prospectus={prospectus} setProspectus={setProspectus}
                images2={images2} setImages2={setImages2}
                documents={documents} setDocuments={setDocuments}
                uploadUtils={props.uploadUtils} media={props.media} />
        </ExtraInfoFormContainer>
    </>
}